export const UNHANDLED_REJECTION_EVENT_NAME = "membershipsignup:unhandled-rejection";
